import React, { useDeferredValue, useState } from 'react'
import PageHeader from '../../components/PageHeader'
import { Button, Collapse } from 'react-bootstrap'
import { deleteConfirmation } from '../../utils'
import AddCompanyModal from './Add'
import Filter from './Filter'
import { useGetJobQuery, useRemoveJobMutation } from '../../redux/services/JobService'
import useLiveDataTable from '../../hooks/useLiveDataTable'
import CustomPagination from '../../components/CustomPagination'
import { Link,  useNavigate } from 'react-router-dom'

const Jobs = () => {
  const {
    currentPage,
    perPage,
    q,
    searchQuery,   
    setSearchQuery,
    handlePageChange,
    handlePerPageChange,
    handleSearchChange,
    onSearchKeyHandler,
    handleSearchBy,
    searchBy,
  } = useLiveDataTable()

  const [isShow, setIsShow] = useState(false)
  const [isEdit, setIsEdit] = useState(false)
  const [isView, setIsView] = useState(false)
  const [open, setOpen] = useState(false)
  const [query, setQuery] = useState(null)
  const params = useDeferredValue(query)
  const navigate = useNavigate();
  const [removeRequest] = useRemoveJobMutation()

  // id: params?.id ? params?.id : 0
  const {
    data: data2,
    isFetching,
    refetch,
  } = useGetJobQuery({
    id: 0,
    pagination: `?page=${currentPage}&per_page=${perPage}&search_by=${searchBy}&search=${q}${
      params?.id ? '&status=' + params?.id : ''
    }`,
  })
  const drivers = data2?.response?.data?.data
  const total = data2?.response?.data?.total

  const handleAdd = () => {
    setIsEdit(null)
    setIsShow(true)
    // reset()
  }

  const handleEdit = items => {
    setIsEdit(items)
    setIsShow(true)
  }

  const handleView = items => {
    setIsEdit(items)
    setIsView(true)
  }
     const handleAddJob = () => {
    // Navigate to /trips page
    navigate('/add-jobs');
  };


  return (
    <>
      <PageHeader name='Trips' />
      <div className='main-container container-fluid'>
        {' '}
        {/* Start::row-1 */}
        <div className='row'>
          <div className='col-xl-12'>
            <div className='card custom-card'>
              <div className='card-header w-100'>
                <div className='row w-100 m-0'>
              
                  {/* <div className='col-auto p-0 d-flex '>
                    <Button className='btn btn-primary' onClick={handleAdd}>
                      Add Trips
                    </Button>
                  </div> */}
                    <div className='col-auto p-0 d-flex ms-2'>
                    <Button className='btn btn-primary' onClick={handleAddJob}>
                       Add Trips
                    </Button>
                  </div>
                  <div className='col-auto p-0 ms-2'>
                    <Button
                      className='btn btn-primary  '
                      onClick={() => setOpen(!open)} // Toggle collapse
                      aria-controls='collapse-inputs'
                      aria-expanded={open}
                    >
                      <i className='ri-filter-2-fill' />
                    </Button>
                  </div>
                  <div className='col-lg-3 col-5 p-0 ms-auto'>
                    <div className='input-group m-0'>
                      <span
                        className='input-group-text bg-transparent border text-primary'
                        id='basic-addon1'
                      >
                        <i className='ri-search-line' />
                      </span>
                      <input
                        className='form-control'
                        type='text'
                        placeholder='Search Here...'
                        aria-describedby='basic-addon1'
                        value={searchQuery}
                        onKeyUp={e => onSearchKeyHandler(e)}
                        onChange={e => setSearchQuery(e.target?.value)}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <Collapse in={open}>
                <div className='w-100'>
                  <Filter setQuery={setQuery} />
                </div>
              </Collapse>
              <div className='card-body'>
                <CustomPagination
                  isFetching={isFetching}
                  data={drivers}
                  total={total}
                  onChangePage={handlePageChange} // Handle page change
                  onChangeRowsPerPage={handlePerPageChange} // Handle per page change
                  paginationDefaultPage={currentPage} // Set the current page
                  columns={[
                    { name: 'Driver', selector: row => row?.driver?.full_name, sortable: true },
                    { name: 'Pickup Address', selector: row => row.pickup_address, sortable: true },
                    { name: 'Drop-off Address', selector: row => row.drop_address, sortable: true },
                    // { name: 'Selected Date & Time', selector: row => row.selectedDateTime, sortable: true },
                    { name: 'Trip Amount', selector: row => `$${row.job_amount}`, sortable: true },
                    // { name: 'Broker', selector: row => row.broker?.broker_name, sortable: true },
                    {
                      name: 'Factoring Company',
                      selector: row => row.factory_company?.company_name,
                      sortable: true,
                    },
                    {
                      name: 'Show Original Document',
                      selector: row => (row?.show_original_document ? 'Yes' : 'No'),
                      sortable: true,
                    },
                    {
                      name: 'Show Rate to Driver',
                      selector: row => (row?.show_rate_to_driver ? 'Yes' : 'No'),
                      sortable: true,
                    },
                    {
                      name: 'Status',
                      selector: row => <StatusComponent status={row?.status} />,
                      sortable: false,
                    }, // Assigned, Pending, Active, Completed,
                    { name: 'Created At', selector: row => row?.created_at, sortable: true },
                    {
                      name: 'Actions',
                      cell: row => {
                        return (
                          <div className='hstack gap-1 fs-1'>
                            <Link
                              aria-label='view'
                              to={`/job-view/${row?.id}`}
                              className='btn btn-icon btn-sm btn-primary-light btn-wave waves-effect waves-light'
                            >
                              <i className='ri-eye-fill' />
                            </Link>
                            <button
                              aria-label='edit'
                              // onClick={() => navigate(`/jobs/edit/${row?.id}`, { state: { isEdit: row } })}
                              onClick={() => handleEdit(row)}
                              className='btn btn-icon btn-sm btn-info-light btn-wave waves-effect waves-light'
                            >
                              <i className='ri-edit-line' />
                            </button>
                            <a
                              aria-label='delete'
                              onClick={() => deleteConfirmation(() => removeRequest(row?.id))}
                              className='btn btn-icon btn-sm btn-danger-light btn-wave waves-effect waves-light'
                            >
                              <i className='ri-delete-bin-7-line' />
                            </a>
                          </div>
                        )
                      },
                      ignoreRowClick: true,
                      allowOverflow: true,
                      button: true,
                      width: '220px',
                    },
                  ]}
                />
              </div>
            </div>

            {isShow && (
              <AddCompanyModal
                show={isShow}
                handleClose={() => {
                  setIsShow(false)
                  setIsEdit(null)
                }}
                isEdit={isEdit}
              />
            )} 
          </div>
        </div>
      </div>
    </>
  )
}

export default Jobs

// Function to determine the color based on status
export const StatusComponent = ({ status }) => {
  const getStatusColor = status => {
    switch (status?.toString()?.toLowerCase()) {
      case 'assigned':
        return 'green'
      case 'cancelled':
        return 'red'
      case 'active':
        return 'blue'
      case 'pending':
        return 'orange'
      case 'approved':
        return 'green'
      default:
        return 'gray'
    }
  }

  return (
    <span
      className='p-2 rounded-2 d-inline-block text-white'
      style={{ backgroundColor: getStatusColor(status) }}
    >
      {status?.charAt(0)?.toUpperCase() + status?.slice(1)}
    </span>
  )
}
